import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers"; 
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { XhrHttpHandler } from '@aws-sdk/xhr-http-handler';
import { v4 as uuidv4 } from 'uuid';

const AWS_TOKEN_DURATION_SEC = 21600; // 6hours

export function Uploader(s3Bucket, s3Region){
    /**
     Gets a singnular, shared S3 Client
    */
    function getS3Client(){
        let client = null;

        const s3Config = {
            region: s3Region,
            maxRetries : 4,
            credentials: fromCognitoIdentityPool({
                identityPoolId: "us-east-1:4d340d48-1de1-45a5-a033-6f2d300f9123",
                clientConfig: { 
                    region: s3Region   
                }
            }),
            requestHandler: new XhrHttpHandler({}), // overrides default FetchHttpHandler in browsers.
        };

        return (() => {
            if(client == null){
                client = new S3Client(s3Config);
            }
            return client;
        })();
    }

    const slugify = str =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');

    const createNewFileName = originalFileName => {

        const extIndex = originalFileName.lastIndexOf('.');

        let newFileName = originalFileName;
        let ext = "";

        if(extIndex != -1){
            newFileName = originalFileName.substring(0, extIndex);
            ext = originalFileName.substring(extIndex);
        }

        let uniqueMarker = uuidv4();
        uniqueMarker = uniqueMarker.substring(0, uniqueMarker.indexOf('-'));

        newFileName += "-" + uniqueMarker;

        newFileName = slugify(newFileName);
        
        newFileName += ext;

        return newFileName;
    }

    this.uploadFile = async function(file, folder, progressCallback){
        
        // Handle iOS <= 14 issues with blob streams.
        // Taken from: https://github.com/aws/aws-sdk-js-v3/issues/2145#issuecomment-895202280
        function blobStream(blob) {
            let position = 0;
        
            return new ReadableStream({
                async pull(controller) {
        
                    const desiredSize = controller.desiredSize ?? 1000;
            
                    const chunk = blob.slice(
                        position,
                        Math.min(blob.size, position + Math.max(desiredSize, 512 * 1024))
                    );
                    const buffer = await new Response(chunk).arrayBuffer();
                    const uint8array = new Uint8Array(buffer);
                    const bytesRead = uint8array.byteLength;
            
                    position += bytesRead;
                    controller.enqueue(uint8array);
            
                    if (position >= blob.size) controller.close();
                }
            });
        }

        const fileName = createNewFileName(file.name);
        const key = folder + fileName;

        let uploadParams = {
            Bucket: s3Bucket,
            Key: key,
            Body: file
        };

        // iOS <= 14 polyfill
        if (!Blob.prototype.stream) {
            uploadParams.Body = blobStream(uploadParams.Body);
        }

        const s3Client = getS3Client();

        const upload = new Upload({
            client: s3Client,
            params: uploadParams,
            queueSize: 1,
    
            // This will prevent the DELETE request from occuring after canceling. 
            // We're bypassing it because our CORS policy doesn't allow DELETE
            leavePartsOnError: true,
        });

        if(progressCallback){
            upload.on("httpUploadProgress", progressCallback);
        }

        return upload;
    }
};